module.exports = __webpack_public_path__ + "img/img_new_top1.d1982619.png";